import { ListGroup, Badge } from "react-bootstrap";
import { FaCheckDouble, FaRegFileAlt, FaBell, FaHeadset, FaFileSignature, FaCalendarAlt, FaFileContract, FaMoneyCheck, FaMoneyBill, FaEdit, FaCoins, FaFileMedical, FaUserAlt, FaUserFriends, FaRegEye, FaRegIdCard, FaPills, FaNotesMedical, FaMedkit, FaRenren, FaBox, FaRegHandshake, FaBoxes, FaUserInjured, FaUserMd, FaWallet, FaPenSquare, FaEnvelope, FaCreditCard, FaBriefcaseMedical, FaDisease, FaStethoscope, FaChartBar, FaFileMedicalAlt, FaBookOpen, FaDollarSign, FaHome, FaFile, FaTeamspeak, FaFileImport, FaLaptop, FaRProject, FaPaste, FaHistory, FaMapMarkedAlt, FaRobot, FaUserSecret, FaTicketAlt } from "react-icons/fa";
import { TbTicket } from "react-icons/tb";
import { MdInventory, MdPropaneTank } from "react-icons/md";
import { hasPerm, getCurrentUser, prestadorOcultaFaturamento } from "../../common/utils";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const Menu = ({ pathname, faturamentosPendentes, habilitar_indicacao_profissional }) => {

    const { t } = useTranslation(['menu']);
    const dados_usuario = getCurrentUser();

    //prestador marcado no cadastro para nao ver a gestao financeira
    const ocultaFinanceiro = prestadorOcultaFaturamento(dados_usuario);

  return (
    <>
        {dados_usuario.is_superuser && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/home" className="itemMenu" active={pathname.indexOf("/home") !== -1 || pathname === "/"} >
                    <FaHome /> {t('menu:item.home')}
                </ListGroup.Item>
            </ListGroup>
        )}

        {hasPerm("view_agendamentos") && (
            <>
                <div className="list-divider"> <p>{t('menu:section.patientCare')}</p> </div>

                {hasPerm("view_agendamentos") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/agendamentos" className="itemMenu" active={pathname.indexOf("/agendamentos") !== -1} >
                            <FaCalendarAlt /> {t('menu:item.appointments')}
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_atendimentos") && (
                    <>
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/atendimentos" className="itemMenu" active={pathname === "/atendimentos" || pathname === "/atendimentos/"}>
                            <FaHeadset /> {t('menu:item.encounters')}
                        </ListGroup.Item>
                    </ListGroup>
                    </>
                )}

                {hasPerm("view_vouchers") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/vouchers" className="itemMenu" active={pathname.indexOf("/vouchers") !== -1}>
                            <FaTicketAlt /> Vouchers
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_autorizacoes") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/autorizacoes" className="itemMenu" active={pathname.indexOf("/autorizacoes") !== -1} >
                            <FaFileContract /> {t('menu:item.authorizations')}
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_viewatendimentoscompliance") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/compliance" className="itemMenu" active={pathname.indexOf("/compliance") !== -1} >
                            <FaFileContract /> {t('menu:item.therapyCompliance')}
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_exames") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/exames" className="itemMenu" active={pathname.indexOf("/exames") !== -1} >
                            <FaFileMedical /> {t('menu:item.exams')}
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_atendimentos") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/farmacovigilancia" className="itemMenu" active={pathname.indexOf("/farmacovigilancia") !== -1} >
                            <FaFileMedical /> {t('menu:item.pharmacovigilance')}
                        </ListGroup.Item>
                    </ListGroup>
                )}

                {hasPerm("view_atendimentos") && (
                    <ListGroup variant="flush">
                        <ListGroup.Item action href="/atendimentos-receptivo" className="itemMenu" active={pathname === "/atendimentos-receptivo" || pathname === "/atendimentos-receptivo/" } >
                            <FaHeadset /> {t('menu:item.inboundCalls')}
                        </ListGroup.Item>
                    </ListGroup>
                )}
                {hasPerm('view_farmacovigilancia') && (
                    <ListGroup variant="flush">   
                        <ListGroup.Item 
                            action 
                            href="/reportes-farmaco"
                            className="itemMenu" 
                            active={pathname.indexOf("/reportes-farmaco") !== -1}
                        >
                            <FaFileMedicalAlt /> {t('menu:item.pvReports')}
                        </ListGroup.Item>      
                    </ListGroup>
                )}  
            </>
        )}

        {hasPerm("pode_gerar_relatorio") && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/relatorios" className="itemMenu" active={pathname === "/relatorios" || pathname === "/relatorios/"} >
                    <FaChartBar /> {t('menu:item.reports')}
                </ListGroup.Item>
                <ListGroup.Item action href="/relatorios/duplicidades" className="itemMenu" active={pathname.indexOf("/relatorios/duplicidades") !== -1} >
                    <FaCheckDouble /> {t('menu:item.duplicatesReport')}
                </ListGroup.Item>
            </ListGroup>
        )}

            {/* GESTÃO FINANCEIRA ADMIN */}
            {/* cada item tem o gate da permissão que a própria API cobra: quem só cuida do
                financeiro precisa da seção sem receber acesso à base de atendimentos */}
            {!ocultaFinanceiro && (hasPerm("view_creditos_antecipacao") || hasPerm("view_atendimentos_servicos") || hasPerm("view_atendimentos") || hasPerm("view_faturamentos")) && (
                <div className="list-divider"> <p>{t('menu:section.financial')}</p> </div>
            )}

            {!ocultaFinanceiro && hasPerm("view_creditos_antecipacao") && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/creditosantecipacao" className="itemMenu" active={pathname.indexOf("/creditosantecipacao") !== -1} >
                        <FaMoneyBill /> {t('menu:item.advanceCredit')}
                    </ListGroup.Item>
                </ListGroup>
            )}

            {!ocultaFinanceiro && hasPerm("view_atendimentos") && hasPerm("view_agendamentos_despesas") && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/despesas" className="itemMenu" active={pathname === "/despesas"} >
                        <FaDollarSign /> {t('menu:item.appointmentExpenses')}
                    </ListGroup.Item>
                </ListGroup>
            )}

            {!ocultaFinanceiro && (hasPerm("view_atendimentos_servicos") || hasPerm("view_atendimentos")) && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/extratoservicos" className="itemMenu" active={pathname === "/extratoservicos"} >
                        <FaMoneyCheck /> {t('menu:item.serviceStatement')}
                    </ListGroup.Item>
                </ListGroup>
            )}

            {!ocultaFinanceiro && hasPerm("view_faturamentos") && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/faturamentos" className="itemMenu" active={pathname.indexOf("/faturamentos") !== -1} >
                        <FaCoins /> {t('menu:item.billing')}
                        {faturamentosPendentes > 0 && (
                            <Badge pill bg="danger" className="ms-2">
                                {faturamentosPendentes}
                            </Badge>
                        )}
                    </ListGroup.Item>
                </ListGroup>
            )}

        {(hasPerm("view_tipoequipamento") || hasPerm("view_projetoinventario") || hasPerm("view_equipamento")) && (
            <>
            <div className="list-divider"> <p>{t('menu:section.inventory')}</p> </div>

            {hasPerm("view_tipoequipamento") && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/tipo-equipamento" className="itemMenu" active={pathname === "/tipo-equipamento"} >
                        <FaLaptop /> {t('menu:item.equipmentTypes')}
                    </ListGroup.Item>
                </ListGroup>
            )}

            {hasPerm("view_projetoinventario") && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/projeto" className="itemMenu" active={pathname === "/projeto"} >
                        <FaPaste /> {t('menu:item.projects')}
                    </ListGroup.Item>
                </ListGroup>
            )}

            {hasPerm("view_equipamento") && (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/inventario" className="itemMenu" active={pathname === "/inventario"} >
                        <MdInventory /> {t('menu:item.inventory')}
                    </ListGroup.Item>
                </ListGroup>
            )}
            </>
        )}

        {hasPerm("view_chamados") && dados_usuario.is_superuser && (
            <>
            <div className="list-divider">
                <p>{t('menu:section.support')}</p>
            </div>
            <ListGroup variant="flush">
                <ListGroup.Item action href="/chamados" className="itemMenu" active={pathname.indexOf("/chamados") !== -1} >
                <TbTicket /> {t('menu:item.tickets')}
                </ListGroup.Item>

                <ListGroup.Item action href="/notificacoes" className="itemMenu" active={pathname.indexOf("/notificacoes") !== -1}>
                    <FaBell /> {t('menu:item.notifications')}
                </ListGroup.Item>
                <ListGroup.Item action href="/faq" className="itemMenu" active={pathname === "/faq" || (pathname.startsWith("/faq/") && pathname.indexOf("faq-areas") === -1)}>
                    <FaTeamspeak /> {t('menu:item.faq')}
                </ListGroup.Item>
            </ListGroup>
            </>
        )}

        {hasPerm("view_ceaf_auditoria_chatbot") && dados_usuario.is_superuser && (
        <>
            <div className="list-divider">
                <p>{t('menu:section.chatbot')}</p>
            </div>
            <ListGroup variant="flush">
                <ListGroup.Item action href="/fluxo-ceaf" className="itemMenu" active={pathname.indexOf("/fluxo-ceaf") !== -1}>
                        <FaMapMarkedAlt /> {t('menu:item.ceafFlow')}
                </ListGroup.Item>
                {(dados_usuario.is_superuser || dados_usuario.tipo_usuario === 'operador') && (
                    <ListGroup.Item action href="/historico-chatbot" className="itemMenu" active={pathname.indexOf("/historico-chatbot") !== -1}>
                            <FaRobot /> {t('menu:item.chatbotHistory')}
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
        )}

    {/* Gerenciamento de Programas e Pacientes ADMIN */}
    {(hasPerm('view_clientes') || hasPerm('view_programas') || hasPerm('view_gestores') || hasPerm('view_operadores') || hasPerm('view_prestadores') || hasPerm('view_planos') || hasPerm('view_carteiras') || hasPerm("view_exames_status")) && (
        <>
            <div className="list-divider"> <p>{t('menu:section.programsAndPatients')}</p> </div>

            <ListGroup variant="flush">   
                {hasPerm('view_carteiras') && (
                    <ListGroup.Item action href="/carteiras" className="itemMenu" active={pathname.indexOf('/carteiras') !== -1}>
                        <FaWallet /> {t('menu:item.portfolios')}
                    </ListGroup.Item>
                )}
                {hasPerm("view_clientes") && (
                    <ListGroup.Item action href="/clientes" className="itemMenu" active={pathname.indexOf("/clientes") !== -1} >
                        <FaRegHandshake /> {t('menu:item.clients')}
                    </ListGroup.Item>
                    )}
                    
                {hasPerm("view_ultracarePspAtendimentosCompleto") && (
                    <ListGroup.Item action href="/codveeva" className="itemMenu" active={pathname.indexOf("/codveeva") !== -1} >
                        <FaEdit /> {t('menu:item.veevaCode')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_exames_status") && (
                    <ListGroup.Item action href="/status-exames" className="itemMenu" active={pathname.indexOf("/status-exames") !== -1} >
                        <FaBookOpen /> {t('menu:item.examStatuses')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_formularios") && (
                    <ListGroup.Item action href="/formularios" className="itemMenu" active={pathname.indexOf("/formularios") !== -1} >
                        <FaRegFileAlt /> {t('menu:item.forms')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_gestores") && (
                    <ListGroup.Item action href="/gestores" className="itemMenu" active={pathname.indexOf("/gestores") !== -1} >
                        <FaUserMd /> {t('menu:item.managers')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_prestadores") && (
                    <ListGroup.Item action href="/medicos" className="itemMenu" active={pathname.indexOf("/medicos") !== -1} >
                        <FaUserMd /> {t('menu:item.doctors')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_operadores") && (
                    <ListGroup.Item action href="/operadores" className="itemMenu" active={pathname.indexOf("/operadores") !== -1} >
                        <FaUserMd /> {t('menu:item.navigators')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_planos") && (
                    <ListGroup.Item action href="/planos" className="itemMenu" active={pathname.indexOf("/planos") !== -1} >
                        <FaBoxes /> {t('menu:item.plans')}
                    </ListGroup.Item>
                )}

                {/* só superadmin: o gestor acessa o programa dele por "Configurações do Programa" (MenuGestor).
                    tipo_usuario vazio não serve aqui — também fica vazio para quem não tem restrição cadastrada */}
                {hasPerm("view_programas") && dados_usuario.is_superuser && (
                    <ListGroup.Item action href="/programas" className="itemMenu" active={pathname.indexOf("/programas") !== -1 && pathname.indexOf("/programas/faq-areas") === -1} >
                        <FaBox /> {t('menu:item.programs')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_prestadores") && (
                    <ListGroup.Item action href="/prestadores" className="itemMenu" active={pathname.indexOf("/prestadores") !== -1} >
                        <FaUserMd /> {t('menu:item.providers')}
                    </ListGroup.Item>
                )}

                {/* a flag vem do programa em contexto. O superadmin costuma navegar sem
                    programa selecionado, e a fila dele e justamente a de todos os programas --
                    exigir a flag aqui escondia o menu dele. */}
                {hasPerm("view_prestadores")
                    && (habilitar_indicacao_profissional || dados_usuario.is_superuser) && (
                    <ListGroup.Item action href="/indicacoes-recebidas" className="itemMenu" active={pathname.indexOf("/indicacoes-recebidas") !== -1} >
                        <FaRegHandshake /> Indicações Recebidas
                    </ListGroup.Item>
                )}

                {hasPerm("view_beneficiarios") && (
                    <ListGroup.Item action href="/pacientes" className="itemMenu" active={pathname.indexOf("/pacientes") !== -1} >
                        <FaUserInjured /> {t('menu:item.patientList')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_centros_referencia") && (
                    <ListGroup.Item action href="/centros-referencia" className="itemMenu" active={pathname.indexOf("/centros-referencia") !== -1} >
                        <FaBoxes/> {t('menu:item.referenceCenters')}
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
    )}

    {/* Configurações e Parametrizações ADMIN */}
    {(hasPerm('view_produtos') || hasPerm('view_termos') || hasPerm("view_termoplataforma") || hasPerm('view_servicos_procedimentos') || hasPerm('view_doencas') || hasPerm('view_modelos_mensagem') || hasPerm('view_emails') || hasPerm('view_formas_pagamento') || hasPerm('view_campos_personalizados') || hasPerm('view_campos_personalizados_atendimentos') || hasPerm('view_especialidades_medicas') || hasPerm('view_especialidade_multiprofissional') || hasPerm('view_categorias_multiprofissional') || hasPerm('view_farmacias') || hasPerm('view_tipos_programa') || hasPerm('view_feriado')) && (
        <>
            <div className="list-divider"> <p>{t('menu:section.settings')}</p> </div>
            
            <ListGroup variant="flush">
                {hasPerm('view_crms') && (
                    <ListGroup.Item action href="/base" className="itemMenu" active={pathname.indexOf('/base') !== -1}>
                        <FaEdit  /> {t('menu:item.crmBase')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_programas') && (
                    <ListGroup.Item action href="/programas/faq-areas" className="itemMenu" active={pathname.indexOf('/programas/faq-areas') !== -1}>
                        <FaTeamspeak /> {t('menu:item.faqAreas')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_campos_personalizados_atendimentos') && (
                    <ListGroup.Item action href="/campos-personalizados-atendimentos" className="itemMenu" active={pathname === '/campos-personalizados-atendimentos'}>
                        <FaPenSquare /> {t('menu:item.customFieldsEncounters')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_campos_personalizados') && (
                    <ListGroup.Item action href="/campos-personalizados" className="itemMenu" active={pathname === '/campos-personalizados'}>
                        <FaPenSquare  /> {t('menu:item.customFieldsPatients')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_emails') && (
                    <ListGroup.Item action href="/emails-notificacao" className="itemMenu" active={pathname.indexOf('/emails-notificacao') !== -1}>
                        <FaEnvelope  /> {t('menu:item.notificationEmails')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_formas_pagamento') && (
                    <ListGroup.Item action href="/formaspagamento" className="itemMenu" active={pathname.indexOf('/formaspagamento') !== -1}>
                        <FaCreditCard  /> {t('menu:item.paymentMethods')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_modelos_mensagem') && (
                    <ListGroup.Item action href="/modelos-mensagem" className="itemMenu" active={pathname.indexOf('/modelos-mensagem') !== -1}>
                        <FaRegIdCard  /> {t('menu:item.messageTemplates')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_produtos') && (
                    <ListGroup.Item action href="/produtos" className="itemMenu" active={pathname.indexOf('/produtos') !== -1}>
                        <FaBriefcaseMedical  /> {t('menu:item.products')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_doencas') && (
                    <ListGroup.Item action href="/doencas" className="itemMenu" active={pathname.indexOf('/doencas') !== -1}>
                        <FaDisease  /> {t('menu:item.treatmentProtocols')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_servicos_procedimentos') && (
                    <ListGroup.Item action href="/servicos" className="itemMenu" active={pathname.indexOf('/servicos') !== -1}>
                        <FaStethoscope /> {t('menu:item.servicesProcedures')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_termos') && (
                    <ListGroup.Item action 
                    href="/termos" 
                    className="itemMenu" 
                    active={
                            pathname === "/termos" ||
                            pathname.startsWith("/termos/")
                            }>
                        <FaEdit  /> {t('menu:item.terms')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_termoplataforma") && ( 
                                    <ListGroup.Item 
                                        action 
                                        href="/termos-plataforma" 
                                        className="itemMenu" 
                                        active={
                                                pathname === "/termos-plataforma" ||
                                                pathname.startsWith("/termos-plataforma/")
                                                }
                                    >
                                        <FaFileSignature /> {t('menu:item.platformTerms')}
                                    </ListGroup.Item>
                                )}

                {hasPerm('view_tipos_programa') && (
                    <ListGroup.Item action href="/tipos-programa" className="itemMenu" active={pathname.indexOf('/tipos-programa') !== -1}>
                        <FaEnvelope  /> {t('menu:item.programTypes')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_feriado') && (
                    <ListGroup.Item action href="/feriados" className="itemMenu" active={pathname.indexOf('/feriados') !== -1}>
                        <FaCalendarAlt /> Feriados
                    </ListGroup.Item>
                )}

                {dados_usuario.is_superuser && (
                    <ListGroup.Item action href="/formularios-eventos" className="itemMenu" active={pathname.indexOf('/formularios-eventos') !== -1}>
                        <FaFileSignature /> {t('menu:item.formsByEvent')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_pesquisas') && (
                    <></>
                /*
                <ListGroup.Item action href="/pesquisas" className="itemMenu" active={this.location.pathname.indexOf('/pesquisas') !== -1}>
                    <FaStar /> {t('menu:item.surveys')}
                </ListGroup.Item>
                */
                )}
            </ListGroup>
        </>
    )}

    {hasPerm("view_chamados") && !dados_usuario.is_superuser && (
        <>
        <div className="list-divider">
            <p>{t('menu:section.support')}</p>
        </div>
        <ListGroup variant="flush">
            <ListGroup.Item action href="/chamados" className="itemMenu" active={pathname.indexOf("/chamados") !== -1} >
                <TbTicket /> {t('menu:item.tickets')}
            </ListGroup.Item>
            <ListGroup.Item action href="/notificacoes" className="itemMenu" active={pathname.indexOf("/notificacoes") !== -1}>
                <FaBell /> {t('menu:item.notifications')}
            </ListGroup.Item>
        </ListGroup>
        </>
    )}

    {/* Especialidades e Profissionais ADMIN */}
    {(hasPerm("view_categorias_multiprofissional") || hasPerm("view_especialidades_medicas") || hasPerm("view_especialidade_multiprofissional") || hasPerm("view_farmacias") ) && (
        <>
            <div className="list-divider"> <p>{t('menu:section.specialtiesAndProfessionals')}</p> </div>

            <ListGroup variant="flush">
                {hasPerm('view_categorias_multiprofissional') && (
                    <ListGroup.Item action href="/categorias-multiprofissional" className="itemMenu" active={pathname.indexOf('/categorias-multiprofissional') !== -1}>
                        <FaNotesMedical  /> {t('menu:item.multiprofessionalCategories')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_especialidades_medicas') && (
                    <ListGroup.Item action href="/especialidades-medicas" className="itemMenu" active={pathname.indexOf('/especialidades-medicas') !== -1}>
                        <FaMedkit  /> {t('menu:item.medicalSpecialties')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_especialidade_multiprofissional') && (
                    <ListGroup.Item action href="/especialidade-multiprofissional" className="itemMenu" active={pathname.indexOf('/especialidade-multiprofissional') !== -1}>
                        <FaRenren  /> {t('menu:item.multiprofessionalSpecialties')}
                    </ListGroup.Item>
                )}

                {hasPerm('view_farmacias') && (
                    <ListGroup.Item action href="/farmacias" className="itemMenu" active={pathname.indexOf('/farmacias') !== -1}>
                        <FaPills  /> {t('menu:item.pharmacies')}
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
    )}

    {/* Mensageria ADMIN */}
    {(hasPerm("view_atendimentos_hi_platform") || hasPerm("view_goto_connect") || hasPerm("view_logs") || dados_usuario.is_superuser) && (
        <>
            <div className="list-divider"> <p>{t('menu:section.messaging')}</p> </div>

            <ListGroup variant="flush">
                {hasPerm("view_atendimentos_hi_platform") && (
                    <ListGroup.Item action href="/atendimentos-hi-platform" className="itemMenu" active={pathname.indexOf("/atendimentos-hi-platform") !== -1} >
                        <FaUserAlt /> {t('menu:item.hiPlatformEncounters')}
                    </ListGroup.Item>
                )}
                {hasPerm("view_goto_connect") && (
                    <ListGroup.Item action href="/goto-connect" className="itemMenu" active={pathname.indexOf("/goto-connect") !== -1} >
                        <FaUserAlt /> {t('menu:item.gotoConnect')}
                    </ListGroup.Item>
                )}
                {hasPerm("view_logs") && (
                    <ListGroup.Item action href="/historico-email" className="itemMenu" active={pathname.indexOf("/historico-email") !== -1} >
                        <FaEnvelope /> {t('menu:item.emailHistory')}
                    </ListGroup.Item>
                )}
                {dados_usuario.is_superuser && (
                    <ListGroup.Item action href="/visualizador-json-jivo" className="itemMenu" active={pathname.indexOf("/visualizador-json-jivo") !== -1} >
                        <FaFileImport /> {t('menu:item.jivoJsonViewer')}
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
    )}

      {(hasPerm("view_pendentes") || dados_usuario.is_superuser) && (
        <>
          <div className="list-divider">
            <p>{t('menu:section.files')}</p>
          </div>
          <ListGroup variant="flush">
                <ListGroup.Item action href="/arquivos" className="itemMenu" active={pathname === "/arquivos" || pathname === "/arquivos/"} >
                    <FaFile /> {t('menu:item.files')}
                </ListGroup.Item>
                {dados_usuario.is_superuser && (
                    <ListGroup.Item action href="/importacao-arquivos" className="itemMenu" active={pathname.indexOf("/importacao-arquivos") !== -1}>
                        <FaFileImport /> {t('menu:item.fileImport')}
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
      )}

      {/* Administração de Usuários ADMIN */}
      {(hasPerm("view_usuarios") || hasPerm("view_grupos") || hasPerm("view_logentry")) && dados_usuario.is_superuser && (
        <>
          <div className="list-divider">
            <p>{t('menu:section.userAdmin')}</p>
          </div>
          <ListGroup variant="flush">
                {hasPerm("add_grupos") && (
                    <ListGroup.Item action href="/grupos" className="itemMenu" active={pathname.indexOf("/grupos") !== -1} >
                        <FaUserFriends /> {t('menu:item.groups')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_logentry") && (
                    <ListGroup.Item action href="/logs" className="itemMenu" active={pathname.indexOf("/logs") !== -1} >
                        <FaRegEye /> {t('menu:item.logs')}
                    </ListGroup.Item>
                )}

                {hasPerm("view_usuarios") && (
                    <ListGroup.Item action href="/usuarios" className="itemMenu" active={pathname.indexOf("/usuarios") !== -1} >
                        <FaUserAlt /> {t('menu:item.users')}
                    </ListGroup.Item>
                )}
            </ListGroup>
        </>
      )}

      {dados_usuario.is_superuser && (
        <>
          <div className="list-divider">
            <p>{t('menu:section.system')}</p>
          </div>
          <ListGroup variant="flush">
                <ListGroup.Item action href="/changelog" className="itemMenu" active={pathname.indexOf("/changelog") !== -1} >
                    <FaHistory /> {t('menu:item.changelog')}
                </ListGroup.Item>
                <ListGroup.Item action href="/suporte/anonimizacao" className="itemMenu" active={pathname.indexOf("/suporte/anonimizacao") !== -1} >
                    <FaUserSecret /> {t('menu:item.anonymization')}
                </ListGroup.Item>
          </ListGroup>
        </>
      )}
    </>
  );
};

Menu.propTypes = {
  pathname: PropTypes.string.isRequired,
  faturamentosPendentes: PropTypes.number.isRequired,
  habilitar_indicacao_profissional: PropTypes.bool
};

export default Menu;
